<template>
    <v-container
        fluid
    >
        <!--<div class="subheading grey&#45;&#45;text text&#45;&#45;darken-1 pl-4 pb-2">Details</div>-->
        <v-layout
            row
        >
            <v-flex
                xs12
            >
                <v-card
                    v-if="consent && consent.Intent"
                >
                    <v-card-text>
                        <v-flex xs11>
                            <div class="headline mb-1">{{ consent.DataOwnerCode }}</div>
                            <div class="title mb-3">{{ consent.Intent.ShortDescription }}</div>
                            <div class="subheading mb-3">{{ consent.Intent.Description }}</div>

                            <v-layout row class="">
                                <v-flex xs1 class="label body-2 grey--text text--darken-1">Expires by</v-flex>
                                <v-flex xs11 class="body-2">{{ userReadable(consent.Expiration) }}</v-flex>
                            </v-layout>

                            <v-layout row class="mt-2">
                                <v-flex xs1 class="label caption grey--text text--darken-1">Issuer</v-flex>
                                <v-flex xs11 class="caption">{{ consent.IntentIssuerCode }}</v-flex>
                            </v-layout>
                            <v-layout row>
                                <v-flex xs1 class="label caption grey--text text--darken-1">Intent</v-flex>
                                <v-flex xs11 class="caption">{{ consent.IntentCode }}</v-flex>
                            </v-layout>
                            <v-layout row>
                                <v-flex xs1 class="label caption grey--text text--darken-1">Owner</v-flex>
                                <v-flex xs11 class="caption">{{ consent.DataOwnerCode }}</v-flex>
                            </v-layout>
                        </v-flex>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import moment from 'moment';
    import { mapState } from 'vuex';

    export default {
        name: 'Consent',
        props: {
            issuer: { type: String, required: true },
            intent: { type: String, required: true },
            user: { type: String, required: true },
        },
        data() {
            return {
            };
        },
        computed: {
            ...mapState('consents', {
                consent: state => state.consent,
            }),
        },
        methods: {
            userReadable(date) {
                return moment(date).format('LLL');
            },
        },
        created() {
            const issuer = this.issuer;
            const intent = this.intent;
            const user = this.user;

            this.$store.commit('nav/BREADCRUMBS', [
                { id: 'consents', text: 'Consents', to: '/consents' },
                { id: 'details', text: 'Details', to: `/consents/${issuer}/${intent}/${user}` },
            ]);

            this.$store.dispatch('consents/LOAD_CONSENT', { issuer, intent, user });
        },
    };
</script>

<style lang="stylus" scoped>
    .v-container
        min-height: 0

    .flex
        .label
            &:after
                content: ":"
</style>



// WEBPACK FOOTER //
// Consent.vue?15c2bdee